import { Injectable } from '@angular/core';
import { JoinRoleComponent } from './join-role/join-role.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class RoleUIService {

  constructor(
    private dialog: MatDialog
  ) { }

  public openJoinRole(assignedSchoolDSNS?: string) {
    this.dialog.open(JoinRoleComponent, {
      width: 'calc(100% - 1.5rem * 2)',
      maxWidth: '52.5rem',
      autoFocus: true,
      data: {
        assignedSchoolDSNS
      }
    });
  }
}
